import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import RoutesComponent from '../src/routes/routesComponent.js'; // Adjust if needed
import './App.css';
import Footer from './NewUPT/shared/Footer.jsx';

function App() {
  return (
    <Router>
      <div className="App">
        <RoutesComponent />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
